export const CHANGE_FONT_SIZE = `CHANGE_FONT_SIZE`;
export const TOGGLE_HIGH_CONTRAST_MODE = `TOGGLE_HIGH_CONTRAST_MODE`;
